// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3JFGi","col":"styles_col__34Ax_"};